import { createUseStyles } from 'react-jss';

export default createUseStyles({
  container: {
    position: 'relative',
    height: '100%',
    '@media(max-width: 900px)': {
      height: '400px',
    }
  },
  headerContainer: {
    position: 'absolute',
    width: '100%',
    zIndex: 1,
  },
  mainSection: {
    display: 'flex',
    height: '100%',
    alignItems: 'center',
    '@media(max-width: 900px)': {
      flexDirection: 'column',
    }
  },
  starRatingWrapper: {
    display: 'flex',
    flexDirection: 'column',
    width: '200px',
    alignItems: 'center',
    marginLeft: '60px',
    marginRight: '40px',
    '@media(max-width: 900px)': {
      width: '100%',
      marginLeft: 0,
      marginRight: 0,
      marginTop: '50px',
    }
  },
  ratingValue: {
    color: '#647276',
    fontFamily: 'Poppins, sans-serif',
    fontSize: '30px',
    fontWeight: 500,
    marginBottom: '10px',
    '@media(max-width: 900px)': {
      marginBottom: 0,
    }
  },
  starRatingLabel: {
    marginTop: '10px',
  },
  iconLabel: {
    marginLeft: '10px',
    fontSize: '14px',
  },
});
